import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { HIGHLIGHT_COLORS } from "../lib/verseHighlightsApi";

/**
 * Floating menu: 4 highlight colors + remove. Positioned near anchorRect.
 */
export function VerseHighlightMenu({ anchorRect, onSelectColor, onRemove, onClose }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  useEffect(() => {
    const onDown = (e) => {
      if (e.target.closest?.("[data-verse-highlight-menu]")) return;
      onClose();
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [onClose]);

  if (!anchorRect) return null;

  const pad = 8;
  let top = anchorRect.bottom + pad;
  let left = anchorRect.left;
  const menuWidth = 220;
  const menuMaxH = 280;
  if (left + menuWidth > window.innerWidth - pad) {
    left = Math.max(pad, window.innerWidth - menuWidth - pad);
  }
  if (top + menuMaxH > window.innerHeight - pad) {
    top = Math.max(pad, anchorRect.top - menuMaxH - pad);
  }

  return createPortal(
    <div
      data-verse-highlight-menu
      className="pointer-events-auto fixed z-[100] flex flex-col gap-2 rounded-xl border border-[#3B82F6]/35 bg-white/95 p-2 shadow-xl backdrop-blur-sm dark:border-[#60a5fa]/30 dark:bg-[#0f1f35]/95"
      style={{ top, left, minWidth: menuWidth }}
      role="dialog"
      aria-label="Verse highlight"
    >
      <div className="text-[10px] font-semibold uppercase tracking-wider text-[#64748B] px-1 dark:text-[#94a3b8]">
        Highlight
      </div>
      <div className="flex flex-wrap gap-1.5">
        {HIGHLIGHT_COLORS.map((c) => (
          <button
            key={c.id}
            type="button"
            title={c.label}
            onClick={() => onSelectColor(c.id)}
            className={`h-9 w-9 rounded-lg border border-[#3B82F6]/20 transition-transform hover:scale-105 active:scale-95 ${c.className}`}
            aria-label={`Highlight ${c.label}`}
          />
        ))}
      </div>
      <button
        type="button"
        onClick={onRemove}
        className="rounded-lg border border-red-300/80 bg-red-50 px-2 py-1.5 text-xs font-semibold text-red-800 transition-colors hover:bg-red-100 dark:border-red-500/40 dark:bg-red-950/40 dark:text-red-200 dark:hover:bg-red-950/70"
      >
        Remove highlight
      </button>
    </div>,
    document.body
  );
}
